import { Injector } from '@angular/core';
import { AccountTypes } from '@finxone-platform/shared/sys-config-types';
import { CurrentAccountsStrategy } from './impl/account-listing-strategies/current-account-listing.strategy';
import { SavingsAccountsStrategy } from './impl/account-listing-strategies/savings-account-listing.strategy';
import { SavingsInternalTransferFormAccountListStrategy } from './impl/account-listing-strategies/savings-internal-transfer-form-account-list.strategy';

export class WidgetsStrategyProvider {
  constructor(private injector: Injector) {}

  public getAccountListingStrategy(context: AccountTypes): any {
    const accountListingStrategies: Record<AccountTypes | 'account', any> = {
      [AccountTypes.CURRENT_ACCOUNT]: CurrentAccountsStrategy,
      [AccountTypes.SAVINGS_ACCOUNT]: SavingsAccountsStrategy,
      [AccountTypes.OPEN_EASY_ACCESS_SAVINGS_ACCOUNT]: SavingsInternalTransferFormAccountListStrategy,
      [AccountTypes.SAVINGS_INTERNAL_TRANSFER_ACCOUNT_FORM_CONTEXT]:
        SavingsInternalTransferFormAccountListStrategy,
      account: CurrentAccountsStrategy, // for backward compatibility as some old widgets might have this as account context
    };
    const strategy = accountListingStrategies[context];
    return this.injector.get(strategy as any);
  }
}
